export default __webpack_public_path__ + "static/media/pirentz-mobile-landing.b8b80c7f.png";